import { render, staticRenderFns } from "./BuyBoxNew.vue?vue&type=template&id=d80fd428&scoped=true"
import script from "./BuyBoxNew.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuyBoxNew.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BuyBoxNew.vue?vue&type=style&index=0&id=d80fd428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80fd428",
  null
  
)

export default component.exports